<template lang="pug">
  v-dialog.grey(v-model="dialog" max-width="400")
    template(v-slot:activator="{ on }")
      slot(:on="on")
    v-card
      v-card-title.d-flex.flex-nowrap.justify-space-between.title
        span {{ title }}
        v-btn(@click="dialog = false" icon)
          v-icon mdi-close
      v-card-text
        v-row
          v-col(cols="12")
            p {{ description }}
          v-col(cols="12")
            .d-flex.flex-nowrap.justify-space-between
              v-btn(@click="confirm" color="primary") {{ okText }}
              v-btn(@click="dialog = false") {{ cancelText }}
</template>

<script>
  export default {
    name: "BaseConfirmDialog",
    props:{
      title: {
        type: String,
        default: 'Ventana de confirmación'
      },
      description: {
        type: String,
        default: '¿Está seguro que desea realizar esta acción?'
      },
      okText: {
        type: String,
        default: 'Ok'
      },
      cancelText: {
        type: String,
        default: 'Cancel'
      },
    },
    data:() => ({
      dialog: false,
    }),
    methods:{
      confirm(){
        this.dialog = false;
        this.$emit('confirm');
      }
    }
  }
</script>

<style lang="sass">
</style>